/* unplugin-vue-components disabled */import { render } from "./RoundedButton.vue?vue&type=template&id=73d12ac7&scoped=true"
import script from "./RoundedButton.vue?vue&type=script&lang=js"
export * from "./RoundedButton.vue?vue&type=script&lang=js"

import "./RoundedButton.vue?vue&type=style&index=0&id=73d12ac7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73d12ac7"]])

export default __exports__